var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-modal',{ref:"modal",staticClass:"modal-BL",attrs:{"title":"Visualizador de Bills of Lading"},on:{"close":function($event){_vm.ActionSetVisibleModalBL(false), _vm.ActionSetZindexTablaModal(false)}}},[_c('BuscarBLPage')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }